import { render, staticRenderFns } from "./emis_facilities.vue?vue&type=template&id=ff6f0a00&scoped=true&"
import script from "./emis_facilities.vue?vue&type=script&lang=js&"
export * from "./emis_facilities.vue?vue&type=script&lang=js&"
import style0 from "./emis_facilities.vue?vue&type=style&index=0&id=ff6f0a00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff6f0a00",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
